import { z } from 'zod';
import { AgentModelSchema } from '../model.js';
export const AgentOutputJsonSchemaSchema = z
    .union([z.boolean(), z.record(z.string(), z.json())])
    .superRefine((schema, context) => {
    try {
        z.fromJSONSchema(schema);
    }
    catch (error) {
        context.addIssue({
            code: 'custom',
            message: error instanceof Error ? error.message : 'Unsupported JSON Schema',
        });
    }
});
export const AgentThinkingLevelSchema = z.enum([
    'minimal',
    'low',
    'medium',
    'high',
    'xhigh',
    'max',
]);
export const RunAgentSessionRequestSchema = z.object({
    instructions: z.string().trim().min(1).max(100_000),
    model: AgentModelSchema.optional(),
    outputSchema: AgentOutputJsonSchemaSchema.optional(),
    thinkingLevel: AgentThinkingLevelSchema.optional(),
});
export const AgentRunSuccessSchema = z
    .object({
    outcome: z.literal('success'),
    output: z.json(),
})
    .strict();
export const AgentRunFailureSchema = z
    .object({
    error: z
        .object({
        code: z.literal('taskFailed'),
        message: z.string().trim().min(1).max(10_000),
    })
        .strict(),
    outcome: z.literal('failure'),
})
    .strict();
export const AgentRunOutcomeSchema = z.discriminatedUnion('outcome', [
    AgentRunSuccessSchema,
    AgentRunFailureSchema,
]);
export const RunAgentSessionResponseSchema = z.discriminatedUnion('outcome', [
    AgentRunSuccessSchema.extend({
        sessionId: z.uuidv7(),
    }),
    AgentRunFailureSchema.extend({
        sessionId: z.uuidv7(),
    }),
]);
export const RunAgentSessionCompletionValidationErrorSchema = z.object({
    error: z.object({
        code: z.literal('completionValidationFailed'),
        message: z.literal('Agent did not submit a valid run completion'),
    }),
    sessionId: z.uuidv7(),
});
//# sourceMappingURL=run.js.map